import React, { useState, useEffect } from "react";
import MasterSideBar from "../../components/MasterSideBar";
import Topbar from "../../components/TopbarNav";
import ReportCaseForm from "../../components/ReportCaseForm";
import MyCases from "../../components/MyCases";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OADisciplinaryPage = () => {
    // --- UI State ---
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    
    const [userId, setUserId] = useState(null);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUserId(parsedUser.id || parsedUser.userId);
            } catch (err) {
                console.error("Error parsing user from localStorage:", err);
            }
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
    };

    if (!userId) {
        return (
            <div className="flex h-screen items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600 mx-auto mb-4"></div>
                    <p className="text-[10px] font-black uppercase tracking-[0.3em] text-gray-400">Loading User Data...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="flex h-screen bg-gray-50 font-sans overflow-hidden">
            {/* MasterSideBar Integration */}
            <MasterSideBar 
                visible={sidebarOpen} 
                onClose={() => setSidebarOpen(false)} 
                onLogout={handleLogout}
                collapsed={sidebarCollapsed} 
                setCollapsed={setSidebarCollapsed} 
            />

            {/* Main Content Area */}
            <div className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0 md:ml-64'}`}>
                <Topbar onSidebarToggle={() => setSidebarOpen(true)} />

                <main className="flex-1 overflow-y-auto p-4 md:p-8 mt-16 lg:mt-20">
                    <div className="max-w-7xl mx-auto space-y-6">
                        
                        {/* Header */}
                        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                            <div>
                                <h1 className="text-2xl md:text-3xl font-black text-gray-800 tracking-tight uppercase">
                                    Disciplinary <span className="text-orange-600">Cases</span>
                                </h1>
                                <p className="text-gray-500 text-[10px] font-black uppercase tracking-widest mt-1 italic">
                                    Report & Track Workplace Incidents
                                </p>
                            </div>
                            <button
                                onClick={() => setShowForm(true)}
                                className="bg-orange-600 text-white px-6 py-3 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-orange-700 transition-all shadow-lg shadow-orange-100"
                            >
                                + Report New Case
                            </button>
                        </div>

                        {/* Modal / Drawer for the Report Form */}
                        {showForm && (
                            <div className="fixed inset-0 z-[100] flex items-center justify-center bg-gray-900/60 backdrop-blur-sm p-4">
                                <div className="bg-white w-full max-w-lg rounded-[2.5rem] shadow-2xl relative overflow-hidden max-h-[90vh] flex flex-col">
                                    {/* Modal Header */}
                                    <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-8 py-6 flex items-center justify-between">
                                        <h2 className="text-xl font-black text-white uppercase tracking-tight">
                                            Report New Case
                                        </h2>
                                        <button
                                            onClick={() => setShowForm(false)}
                                            className="text-white hover:bg-white/20 rounded-full p-2 transition-all"
                                        >
                                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    </div>

                                    {/* Modal Body */}
                                    <div className="p-8 overflow-y-auto flex-1">
                                        <ReportCaseForm
                                            reporterId={userId}
                                            onClose={() => {
                                                setShowForm(false);
                                                toast.success("Case reported successfully! It is now awaiting review.", {
                                                    position: "top-center",
                                                    autoClose: 4000,
                                                    hideProgressBar: false,
                                                    closeOnClick: true,
                                                    pauseOnHover: true,
                                                    draggable: true,
                                                    progress: undefined,
                                                    style: {
                                                        background: "#FFEDD5",
                                                        color: "#92400E",
                                                        fontWeight: "600",
                                                        fontSize: "14px",
                                                        textAlign: "center",
                                                        borderRadius: "16px",
                                                        padding: "16px 24px",
                                                    },
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Component to display their cases */}
                        <div className="bg-white rounded-[2.5rem] shadow-sm border border-gray-100 overflow-hidden">
                            <MyCases userId={userId} />
                        </div>

                        {/* Toast container */}
                        <ToastContainer />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default OADisciplinaryPage;